import React from "react";
import { Subscribe } from "unstated";
import { t } from "@lingui/macro";
// Our modules
import { store } from "../../stores/Main";
import { RolesList, Section } from "../../components";
import { i18n } from "idc-ui-react";

function RolesPage({ store }) {
  const { roles } = store.state.loggedInUser;

  return (
    <Section hero returnLink text={i18n._(t`All Technical Roles`)}>
      {!roles ? (
        <div>{i18n._(t`No Technical Roles assigned yet!`)}</div>
      ) : (
        <RolesList roles={roles} />
      )}
    </Section>
  );
}

const StoreWrapper = () => (
  <Subscribe to={[store]}>{store => <RolesPage store={store} />}</Subscribe>
);

export default StoreWrapper;
